import { SyntheticEvent, useMemo } from "react";
import Autocomplete, { AutocompleteRenderInputParams } from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { CustomerGroup } from "../../../types/customer.type";
import {
  customerGroupLabel,
  generalGroupCandidates,
  isSameCustomerGroup,
} from "./customerGroups";
import { useCustomerGroups } from "./useCustomerGroups";

interface CustomerGroupCodeInputProps {
  value: string;
  /** The code saved now; its group's prefix narrows the choices. */
  savedCode: string;
  error: string | null;
  helperText: string;
  disabled: boolean;
  onChange: (code: string) => void;
}

export default function CustomerGroupCodeInput({
  value,
  savedCode,
  error,
  helperText,
  disabled,
  onChange,
}: Readonly<CustomerGroupCodeInputProps>) {
  const { groups, loading } = useCustomerGroups();

  const options = useMemo(() => generalGroupCandidates(groups, savedCode), [groups, savedCode]);
  const selectedGroup = options.find((group) => group.code === value) ?? null;

  const handleChange = (_event: SyntheticEvent, group: CustomerGroup | null) =>
    onChange(group?.code ?? "");

  const renderInput = (params: AutocompleteRenderInputParams) => (
    <TextField
      {...params}
      size="small"
      placeholder="เลือกหมวดลูกค้า"
      error={Boolean(error)}
      helperText={error ?? helperText}
    />
  );

  return (
    <Autocomplete
      options={options}
      value={selectedGroup}
      onChange={handleChange}
      getOptionLabel={customerGroupLabel}
      isOptionEqualToValue={isSameCustomerGroup}
      renderInput={renderInput}
      loading={loading}
      disabled={disabled}
      noOptionsText="ไม่พบหมวดลูกค้า"
    />
  );
}
